__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-settings/v1_15_2/";